import { z } from "zod";
import { correlationIdSchema } from "./headers";

export const fieldErrorSchema = z
  .object({
    path: z.string().trim().min(1).max(500),
    code: z.string().trim().min(1).max(100),
    message: z.string().trim().min(1).max(1_000),
  })
  .strict();

export const apiProblemDetailsSchema = z
  .object({
    type: z.string().url(),
    title: z.string().trim().min(1).max(200),
    status: z.number().int().min(400).max(599),
    code: z
      .string()
      .trim()
      .regex(/^[A-Z][A-Z0-9_]*$/)
      .max(100),
    detail: z.string().trim().min(1).max(2_000).optional(),
    instance: z.string().trim().min(1).max(500).optional(),
    correlationId: correlationIdSchema,
    fieldErrors: z.array(fieldErrorSchema).max(100).optional(),
    retryable: z.boolean().optional(),
  })
  .strict();

export type ApiProblemDetails = z.infer<typeof apiProblemDetailsSchema>;

